import React from "react";
import { QUOTE_STATUSES, statusOf, ONGOING, isOngoing } from "@/lib/quoteStatus";

// Chips: All · Ongoing (in workshop) · Draft · Approved — "Paid" is managed on the Invoices page
const CHIPS = [ONGOING, ...QUOTE_STATUSES.filter((s) => s.key !== "paid")];

export default function StatusFilter({ quotes, value, onChange }) {
  const counts = quotes.reduce((m, q) => { const k = statusOf(q).key; m[k] = (m[k] || 0) + 1; if (isOngoing(q)) m.ongoing = (m.ongoing || 0) + 1; return m; }, {});
  const won = (counts.approved || 0) + (counts.paid || 0);
  const rate = quotes.length ? Math.round((won / quotes.length) * 100) : 0;
  const chip = "px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors";
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-testid="quotes-status-filter">
      <div className="flex flex-wrap gap-2">
        <button data-on={!value} onClick={() => onChange(null)} data-testid="quotes-filter-all"
          className={`${chip} border-slate-700 text-slate-300 data-[on=true]:bg-amber-500 data-[on=true]:border-amber-500 data-[on=true]:text-slate-950`}>
          All <span className="font-mono-num opacity-80">{quotes.length}</span>
        </button>
        {CHIPS.map((s) => (
          <button key={s.key} data-on={value === s.key} onClick={() => onChange(value === s.key ? null : s.key)} data-testid={`quotes-filter-${s.key}`}
            className={`${chip} ${s.badge} data-[on=true]:ring-2 data-[on=true]:ring-offset-1 data-[on=true]:ring-offset-[#0B1120] data-[on=true]:ring-current`}>
            {s.en} <span className="font-zh opacity-80">{s.zh}</span> <span className="font-mono-num opacity-80">{counts[s.key] || 0}</span>
          </button>
        ))}
      </div>
      <p className="text-xs text-slate-400" data-testid="quotes-conversion">
        <span className="font-mono-num text-emerald-300 font-bold">{rate}%</span> converted · <span className="text-slate-500">payments on Invoices</span>
      </p>
    </div>
  );
}
